<template>
  <b-container fluid>
    <b-row class="mb-2">
      <b-col class="px-sm-3 px-0">
        <h1>Menus</h1>
      </b-col>
      <b-col class="text-right px-sm-3 px-0">
        <b-button
          v-if="hubAdmin"
          variant="primary"
          class="m-1"
          @click="$router.push('menus/create')"
          >Add Menu</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col class="px-sm-3 px-0">
        <b-form inline class="mb-2" @submit.prevent="applyFilters">
          <b-form-input
            v-model="queryFilters.search"
            placeholder="Search by name or id"
            title="Search by name or id"
            class="mr-2 mb-2 single-input"
          />
          <custom-search-field
            v-if="hubCount > 1"
            v-model="queryFilters.hub"
            class="mr-2 mb-2 single-input"
            :placeholder="'Filter by hub'"
            :path-to-search="'facilities'"
          />
          <b-form-group class="custom-search-input mr-2 mb-2">
            <multiselect
              v-model="queryFilters.status"
              select-label=""
              open-direction="bottom"
              :options="statusOptions"
              track-by="value"
              deselect-label="remove"
              :searchable="false"
              :close-on-select="true"
              :show-no-results="false"
              :hide-selected="false"
              label="text"
              placeholder="Filter by status"
              class="single-input"
            />
          </b-form-group>
          <b-button
            type="submit"
            variant="primary"
            class="mr-2 mb-2 float-right"
            >Filter</b-button
          >
        </b-form>
      </b-col>
    </b-row>
    <b-row class="overflow-auto">
      <b-col class="px-sm-3 px-0">
        <b-table
          hover
          no-local-sorting
          small
          :fields="fields"
          :items="data"
          :busy="busy"
          @sort-changed="onSortingChanged"
          @row-clicked="onRowClicked"
        >
          <template #cell(name)="row">
            <router-link :to="`/menus/${row.item.id}`">
              {{ row.item.name }}
            </router-link>
          </template>
          <template #cell(status)="row">
            {{ row.item.status | capitalize }}
          </template>
          <template #cell(hub)="row">
            {{ row.item.facility.name }}
          </template>
          <template #cell(brands)="row">
            {{ row.item.brands.length }}
          </template>
        </b-table>
      </b-col>
    </b-row>

    <pagination-handler v-if="data.length" :query-data="queryFilters" />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import tableMixin from '../../mixins/TableMixin';
import ResourceAPI from '../../services/ResourceAPI';

export default {
  name: 'Menus',
  mixins: [tableMixin],
  data() {
    return {
      statusOptions: [
        {
          value: 'active',
          text: 'Active',
        },
        {
          value: 'inactive',
          text: 'Inactive',
        },
      ],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Menu',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'hub',
          label: 'Hub',
          sortable: false,
        },
        {
          key: 'brands',
          label: '# Brands',
          sortable: true,
        },
      ],
      rowRouteName: 'menu',
      initialFilters: {
        status: { text: 'Active', value: 'active' },
      },
      data: [],
      exportAlert: false,
    };
  },
  computed: {
    ...mapGetters('session', ['hubAdmin', 'hubCount']),
  },
  watch: {
    hubCount(val) {
      if (val === 1) {
        this.removeTableColumn('hub');
      }
    },
  },
  mounted() {
    if (this.hubCount === 1) {
      this.removeTableColumn('hub');
    }
  },
  methods: {
    loadResults() {
      this.setRequestData();
      // Format search params for query
      const searchParams = { ...this.queryFilters };
      searchParams.status = searchParams.status
        ? searchParams.status.value
        : 'active,inactive';
      searchParams.facility = searchParams.hub ? searchParams.hub.id : null;
      searchParams.with = 'facility,brands';

      return ResourceAPI.getRecords('menus', searchParams)
        .then((data) => {
          this.setResponseData(data);
        })
        .catch((error) => alert(error));
    },
  },
};
</script>
